module.exports = __webpack_public_path__ + "static/media/organization_default_logo.5ad613fa.png";